<div class="w-full">
  <div class="flex flex-row items-start gap-4 pl-4 pr-3 py-2">
    <!-- Notification Type Icon -->
    <mat-icon class="w-6 shrink-0" [ngClass]="statelessNotificationsSelectors.iconClassesFor(notification) | select">
      {{ statelessNotificationsSelectors.iconNameFor(notification) | select }}
    </mat-icon>
    <!-- Notification Body -->
    <div class="flex flex-col">
      <p class="text-label-medium text-on-surface-variant">
        {{ statelessNotificationsSelectors.createdFor(notification) | select | format:'DATE_ONLY' }}
      </p>
      <p mxTruncate [mxTruncateMaxLines]="2" class="text-title-medium">
        {{ statelessNotificationsSelectors.displayableTypeLabelFor(notification) | select }}
      </p>
      <p mxTruncate [mxTruncateMaxLines]="4" class="text-body-medium text-on-surface-variant">
        {{ statelessNotificationsSelectors.messageFor(notification) | select }}
      </p>
    </div>
    <!-- "Mark as Read" Button -->
    <mx-icon-button icon="close" color="on-surface-variant" (click)="clearNotification(notification.id)" class="ml-auto -mt-1.5"/>
  </div>
  @if (showDivider) {
    <mat-divider/>
  }
</div>
